import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { IconLlmStop } from '@websolutespa/bom-mixer-icons';
import { useLlm } from '../../../useLlm/useLlm';
import style from './page-stop.module.scss';

export const PageStop: React.FC = () => {
  const label = useLabel();
  const {
    Blob,
  } = useLlm(state => state.components);
  const threadId = useLlm(state => state.threadId);
  const { abort } = useLlm(state => state.actions);
  return (
    <button type="button" className={getClassNames(style.stop)}
      disabled={!threadId}
      aria-disabled={!threadId}
      aria-label={label('llm.stopResponse')}
      onClick={abort}
    >
      <IconLlmStop />
    </button>
  );
};
